import { ICreatorTheme } from "../../../../../features/Common/modules/Theme/theme.interface";
import { getColorsFromCreatorTheme } from "../../../../../features/Common/modules/Theme/utils/Theme.utils";
import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    container: { width: "100%" },
    fadeComment: {},
    commentsTitle: {
      marginBottom: "18px",
    },
    commentsList: {
      display: "flex",
      flexDirection: "column",
      gap: "18px",
    },
    loadMoreCommentsBtn: {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
    },
  },
  componentName: "CommentSection",
});

export const getThemedStyles = ({ theme }: { theme: ICreatorTheme }) => {
  const { color1 } = getColorsFromCreatorTheme(theme);
  return getStylesObjFromCss({
    styles: {
      loadMoreCommentsBtn: {
        color: (color1 || "#493AB1") + " !important",
      },
    },
    componentName: "CommentSection",
  });
};
